import Cookie from "js-cookie";
import { useEffect, useCallback } from "react";

import {
  EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
  EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
} from "../constants";

const EvidonBannerNavigationHotfix = () => {
  const declineEvidonConsent = useCallback(() => {
    window.evidon.notice.dropSuppressionCookie(
      EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS
    );

    Cookie.set(EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE, 1, {
      path: window.evidon.notice._getConsentCookieDomainPath(),
      expires: EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
    });
  });

  useEffect(() => {
    window.evidon.consentDeclinedCallback = declineEvidonConsent;

    return () => {
      delete window.evidon.consentDeclinedCallback;
    };
  }, []);

  return null;
};

export default EvidonBannerNavigationHotfix;
